<ng-template [ngIf]="showSection">
<div class="new-content" *ngIf="!pane || !pane.loaded else contentBlock">
  <loading-line *ngIf="pane.display_mode === 'row'" height="40px" width="100%"></loading-line>
</div>

  <app-skeleton *ngIf="showSkeleton && pane.display_mode !== 'row'" [stats]="'my-classes-users'"></app-skeleton>

<ng-template #contentBlock>
  <div *ngIf="!showSkeleton" class="content">
    <app-chapter [link]="blockTitle?.add_link" [title]="blockTitle.title"></app-chapter>

    <div *ngIf="users.length" class="scroll">
      <div class="tutor-list" [class.cell-row]="pane.display_mode === 'row'">
        <div *ngFor="let user of users; trackBy: trackByFn" class="tutor-item">
          <app-tutor-mini [display_mode]="pane.display_mode"
                          [hide_classes]="true"
                          (clicked)="onShowUser($event)"
                          [user]="user">
          </app-tutor-mini>
        </div>
      </div>
    </div>

    <app-empty *ngIf="showEmptyContent" [empty]="emptyContent"></app-empty>
    <ng-container *ngIf="!users.length && pane.display_mode === 'row'" [ngTemplateOutlet]="noContentStub"></ng-container>
  </div>
</ng-template>

<ng-template #noContentStub>
  <app-no-content-stub
    [icon]="'people'"
    [text]="'my-classes.stub.stub3'">
  </app-no-content-stub>
</ng-template>
</ng-template>
